export const removeAccents = (str) =>
  str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const removeLeadingZeroes = (str?: string): string =>
  str?.replace(/^0+/, '') || '';

export const trimSpaces = (str?: string): string => str?.trim() || '';

export const toCapitalCase = (str: string): string =>
  str?.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

export const trimBrackets = (
  str?: string,
  bracketType: '(' | '[' | '{' = '('
): string => {
  const text = str?.trim() || '';

  let regex = /^\(|\)$/g;
  if (bracketType === '[') regex = /^\[|\]$/g;
  else if (bracketType === '{') regex = /^\{|\}$/g;
  return text.replace(regex, '');
};

export const prependSpaceIfString = (...args: (string | undefined)[]) =>
  args.reduce((acc, str) => {
    if (str) acc += ' ' + str;
    return acc;
  }, '');

export const toLowerKabobCase = (text: string | null | undefined) => {
  if (!text) return '';

  const trimmedText = text.replace(/[^a-zA-Z0-9\s_-]+/g, '').trim();
  return trimmedText.includes(' ')
    ? trimmedText.replace(/[\s_]+/g, '-').toLowerCase()
    : (text?.toUpperCase() === text ? trimmedText.toLowerCase() : trimmedText)
        .replace(/([a-z])([A-Z0-9])/g, '$1-$2')
        .replace(/([A-Z])([A-Z0-9])/g, '$1-$2')
        .replace(/([0-9])([A-Z])/g, '$1-$2')
        .replace(/[\s_]+/g, '-')
        .toLowerCase();
};

/**
 * Formats an array of items into a readable list with proper comma and 'or' placement.
 * Examples:
 *   ['vision'] => 'vision'
 *   ['dental', 'vision'] => 'dental or vision'
 *   ['dental', 'vision', 'behavioral health'] => 'dental, vision, or behavioral health'
 *
 * @param items - Array of items to format
 * @param orWord - The word to use as conjunction (default: 'or'), can be translated
 */
export const formatListWithOr = (
  items: string[],
  orWord: string = 'or',
  delimiter = ','
): string => {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} ${orWord} ${items[1]}`;

  // For 3+ items: join all but last with ', ', then add ', {orWord}' before the last item
  return `${items.slice(0, -1).join(delimiter + ' ')}${delimiter} ${orWord} ${
    items[items.length - 1]
  }`;
};
